module.exports = __webpack_public_path__ + "static/31-84d040bb0d596ed5319b29a23850a28d.gif";